var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',_vm._b({staticClass:"flex-shrink-0",class:_vm.svgClass,attrs:{"aria-hidden":"true","width":_vm.width,"height":_vm.height}},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }